var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7195 5.59964C5.7195 5.29569 5.47208 5.04828 5.16855 5.04828C4.86419 5.04828 4.61719 5.29569 4.61719 5.59964C4.61719 5.90277 4.86378 6.151 5.16855 6.151C5.47208 6.151 5.7195 5.90277 5.7195 5.59964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26628 6.15018C8.57057 6.15018 8.81724 5.90351 8.81724 5.59923C8.81724 5.29495 8.57057 5.04828 8.26628 5.04828C7.962 5.04828 7.71533 5.29495 7.71533 5.59923C7.71533 5.90351 7.962 6.15018 8.26628 6.15018Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71492 7.81539C7.36746 7.81539 7.91104 7.3607 8.0839 6.77985H5.34717C5.5188 7.3607 6.06361 7.81539 6.71492 7.81539Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 0.666075C11.6318 -0.806543 10.251 0.52721 9.7074 1.18835C8.84923 0.523114 7.77395 0.126593 6.60773 0.126593C5.38048 0.126593 4.254 0.564896 3.37658 1.29363C2.90468 0.687375 1.44394 -0.889698 0 0.666075C0 0.666075 0.478857 2.34597 2.58517 2.11657C1.92976 2.97065 1.54021 4.03733 1.54021 5.19494C1.54021 7.98861 3.81365 10.2616 6.60773 10.2616C9.40182 10.2616 11.6748 7.98861 11.6748 5.19494C11.6748 4.04593 11.2906 2.98499 10.6442 2.13419C12.556 2.22308 12.9996 0.666075 12.9996 0.666075ZM6.60773 9.02661C4.49486 9.02661 2.77565 7.3074 2.77565 5.19494C2.77565 4.91475 2.80596 4.64194 2.86331 4.37896H5.31126L5.30142 3.34751L6.35581 4.37896H10.3538C10.4107 4.64235 10.4415 4.91516 10.4415 5.19494C10.4402 7.3074 8.72101 9.02661 6.60773 9.02661Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKids);
export default __webpack_public_path__ + "static/media/Kids.773a755fa97c9c5cdf13d2d63bde7462.svg";
export { ForwardRef as ReactComponent };